var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileMinusAlt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_1621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.662 1.375H5.55093C4.12488 1.375 3.41184 1.375 2.86717 1.65253C2.38804 1.89665 1.99851 2.28618 1.7544 2.7653C1.47687 3.30998 1.47687 4.02301 1.47687 5.44906V20.2175C1.47687 21.6436 1.47687 22.3567 1.7544 22.9013C1.99851 23.3804 2.38804 23.77 2.86717 24.0141C3.41184 24.2916 4.12488 24.2916 5.55093 24.2916H10.3889M11.662 1.375L19.3009 9.01387M11.662 1.375V6.97684C11.662 7.68986 11.662 8.04638 11.8008 8.31872C11.9229 8.55828 12.1176 8.75304 12.3572 8.87511C12.6295 9.01387 12.986 9.01387 13.6991 9.01387H19.3009M19.3009 9.01387V16.0162M6.56945 19.199H9.75231M6.56945 14.1065H14.2083M6.56945 9.01387H7.84259M14.8449 21.1088H21.2106",
    stroke: "#256FFA",
    strokeWidth: 2.54629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_1621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9999,
    height: 25.6666,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMinusAlt1);
export default __webpack_public_path__ + "static/media/file-minus-alt 1.44a9a2d96d57bb0541b255246a912f06.svg";
export { ForwardRef as ReactComponent };